import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import withOnline from '../../common/withOnline';
import withLoader from '../../common/withLoader';
import withTableName from '../../common/withTableName';
import withNotify from '../../common/withNotify';
import { renderField, maxLength50 } from '../../helpers/form-validations';

class CustCaseIDModal extends Component {
  render() {
    const { handleSubmit, onSubmit, onBack } = this.props;
    return (
      <div
        className="modal fade theme-modal qty-modal"
        id="custCaseIDModal"
        tabIndex="-1"
        aria-labelledby="custCaseIDModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <form onSubmit={handleSubmit(onSubmit)} form="custCaseIDForm">
              <div className="modal-body">
                <h5 className="modal-title" id="cancelCaseModalLabel">Add Customer Case ID if available:</h5>
                <div>
                  <Field
                    type="text"
                    name="CustCaseID"
                    className="form-control search-input-focus search-input"
                    placeholder="Customer Case ID"
                    component={renderField}
                    validate={maxLength50}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <div className="row gx-2 button-wrap">
                  <div className="col-6">
                    <button
                      type="button" className="btn btn-link btn-left w-100"
                      data-bs-dismiss="modal"
                      onClick={onBack}
                    >Skip
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      type="submit"
                      className="btn btn-link w-100"
                      data-bs-dismiss="modal"
                    >Next
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'custCaseIDForm',
});

export default withNotify(
  withTableName(
    withLoader(
      withOnline(
        withForm(
          CustCaseIDModal
        )
      )
    )
  )
);
